<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-login/>

        <!-- Main -->
        <main class="loginScreen">
            <div class="container-fluid">
                <div class="row --mainRow">
                    <div class="col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"></div>

                    <!-- Prihlásenie -->
                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-6 paddingBox rightCol">
                        <h2>Prihlásenie</h2>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <div class="row">
                            <div class="col-lg-7 col-xl-7">

                                <!-- Form Box -->
                                <form @submit="formSubmit">
                                    <div class="form-row">
                                        <div class="col-12 col-md-12">
                                            <label>E-mail</label>
                                            <input type="email" class="form-control" v-model="email" required>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12 col-md-12">
                                            <label>
                                                Heslo
                                                <a role="button" class="float-right" @click="$bvModal.show('modalLostPassword')">
                                                    Zabudli sme heslo
                                                </a>
                                            </label>
                                            <input type="password" class="form-control" v-model="password" required>
                                        </div>
                                    </div>

                                    <!-- Login -->
                                    <div class="form-row">
                                        <div class="col-12 col-md-12">
                                            <button class="btn --primary w-100">
                                                Prihlásiť sa <span class="icon"></span>
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <div class="m-separator text-center">
                                    <span>alebo</span>
                                </div>

                                <button @click="fbLogin" class="btn --primary w-100 --facebookNormal mb-5 mb-lg-0">
                                    Prihlásiť sa cez Facebook <span class="icon d-none d-md-inline-block"></span>
                                </button>
                                <!-- .Form Box -->

                            </div>

                            <!-- Benefity -->
                            <div class="col-lg-5 col-xl-5">
                                <aside class="o-widget mb-md-5">
                                    <div class="m-widgetContent">
                                        <div class="m-widgetContent__description">
                                            <p>Tu sa môže trieda prihlásiť, starať sa o svoju kravičku a súťažiť o super ceny.</p>
                                            <h2>Benefity:</h2>
                                        </div>

                                        <ul class="m-widgetContent__list">
                                            <li>starostlivosť o kravičku prináša súťažné body</li>
                                            <li>celá trieda sa spoločne zapája</li>
                                            <li>môžete spolu vyhrať aj cenu pre svoju školu/škôlku</li>
                                        </ul>
                                    </div>
                                </aside>
                            </div>
                            <!-- .Benefity -->

                        </div>
                    </div>
                    <!-- .Prihlásenie -->

                </div>
            </div>

            <!-- Modal -->
            <b-modal id="modalLostPassword" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLostPasswordTitle" aria-hidden="true" ref="modalLostPassword">
                <!-- Close -->
                <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalLostPassword')"><span class="icon"></span></b-button>

                <!-- Content -->
                <div class="modal-body o-modalLostPassword">
                    <div class="m-modalLostPassword__content">
                        <h2 class="m-modalLostPassword__name text-center">Zabudli ste heslo?</h2>
                        <p class="text-center">Ak si zabudol svoje heslo, zadaj svoj email a nové heslo ti bude poslané do emailu</p>
                    </div>

                    <div class="m-modalLostPassword__footer d-flex">

                        <!-- Form Box -->
                        <form @submit="formSubmitResetPwd" class="w-100">
                            <div class="form-row">
                                <div class="col-12 col-md-12">
                                    <input type="email" class="form-control" placeholder="Váš email" v-model="zabudnute_heslo_email">
                                </div>
                            </div>
                            <div class="form-row text-center mb-0">
                                <div class="col-12 col-md-12">
                                    <button @click="$bvModal.hide('modalLostPassword')" class="btn --primary" type="submit">Resetovať</button>
                                </div>
                            </div>
                        </form>
                        <!-- .Form Box -->

                    </div>
                </div>
                <!-- .Content -->
            </b-modal>

        </main>
        <!-- .Main -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderLogin  from './partials/HeaderLogin.vue'
    export default {
        components: {
            HeaderLogin,
            // VFacebookLogin
        },
        props: [
            'reset'
        ],
        mounted() {
            if (!this.reset && localStorage.getItem("token") && localStorage.getItem("token") != '') {
                console.log('autologin')
                this.tryAutoLogin()
            } else {
                console.log('reset')
                this.emitResetProfil()
            }

            window.fbAsyncInit = function() {
                FB.init({
                    appId            : '498025944204213',
                    autoLogAppEvents : true,
                    xfbml            : true,
                    version          : 'v3.3'
                });

                FB.AppEvents.logPageView();
            };

        },
        data() {
            return {
                email: '',
                password: '',
                zabudnute_heslo_email: '',

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // mounted
            tryAutoLogin() {
                // todo if token
                if ( !sessionStorage.getItem("kravickaId") ) {
                    console.log('-> profil')
                    this.$router.push({ name: 'profil' })
                } else {
                    this.$router.push({ name: 'adopcia-udaje', params: { kravicka_id: sessionStorage.getItem("kravickaId") } })
                }
            },

            emitResetProfil() {
                this.$emit('resetProfil')
            },


            // submit
            async formSubmit(e) {
                e.preventDefault()

                try {
                    let { data } = await EventService.authenticateSkoly(this.email, this.password)
                    EventService.saveSkolyTokenToSession(data.access_token)
                } catch (e) {
                    this.responseType = 'danger'
                    if ( e && e.response && e.response.data ) {
                        this.responseText = e.response.data.errors[0][0]
                    } else {
                        this.responseText = e
                    }
                }


                EventService.authenticate(this.email, this.password)
                    .then(response => {
                        //console.log(response.data)
                        if (response.status == 200) {
                            EventService.saveTokenToSession(response.data.data.token)
                            sessionStorage.setItem("login", "success")

                            if ( !sessionStorage.getItem("kravickaId") ) {
                                this.$router.push({ name: 'profil' })
                            }
                            else {
                                this.$router.push({ name: 'adopcia-udaje', params: { kravicka_id: sessionStorage.getItem("kravickaId") } })
                            }
                        } else {
                            this.responseType = 'danger'
                            this.responseText = response.message
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            formSubmitResetPwd(e) {
                e.preventDefault()
                EventService.resetPassword(this.zabudnute_heslo_email)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = 'success'
                        this.responseText = 'Nové heslo bolo zaslané na váš email'
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            fbLogin() {
                // window.location.replace("https://www.adoptujkravicku.sk/hra/")
                let self = this
                FB.login(function(response) {
                    if (response.authResponse) {

                        FB.api('/me', {fields: 'name, email'}, function(userData) {
                            EventService.fbLogin(userData)
                                .then(response => {
                                    self.initAcl()
                                    EventService.saveTokenToSession(response.data.data.access_token)
                                    sessionStorage.setItem("login", "success")
                                    self.$router.push({ name: 'profil' })
                                })
                                .catch(error => {
                                    self.responseType = 'warning'
                                    self.responseText = error
                                })
                        });

                    } else {
                        console.log('User cancelled login or did not fully authorize.');
                    }
                },  { scope: 'email' });
            },

            initAcl() {
                EventService.initializeAcl()
                    .then(response => {
                        console.log(response)
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },
        }
    }
</script>
